
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveal = () => {
    const items = document.querySelectorAll('.om1990-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  };

  const parallax = () => {
    if (reducedMotion) return;
    const items = Array.from(document.querySelectorAll('[data-om1990-parallax]'));
    const hero = document.querySelector('.om1990-orbit');
    const scroller = document.querySelector('.page-wrapper') || window;
    let ticking = false;

    const update = () => {
      const center = window.innerHeight / 2;
      items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const progress = center - (rect.top + rect.height / 2);
        item.style.setProperty('--om1990-scroll', Math.max(-460, Math.min(460, progress)) + 'px');
      });
      ticking = false;
    };

    const schedule = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    scroller.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();

    if (hero) {
      hero.addEventListener('pointermove', (event) => {
        const rect = hero.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 34;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * 30;
        hero.style.setProperty('--om1990-pointer-x', x + 'px');
        hero.style.setProperty('--om1990-pointer-y', y + 'px');
      }, { passive: true });
      hero.addEventListener('pointerleave', () => {
        hero.style.setProperty('--om1990-pointer-x', '0px');
        hero.style.setProperty('--om1990-pointer-y', '0px');
      }, { passive: true });
    }
  };

  const canvasHero = () => {
    if (reducedMotion) return;
    const canvas = document.querySelector('[data-om1990-field]');
    if (!canvas) return;
    const context = canvas.getContext('2d', { alpha: true });
    if (!context) return;
    let width = 0;
    let height = 0;
    let particles = [];
    let pointerX = 0.5;
    let pointerY = 0.5;
    let animationFrame = 0;

    const resize = () => {
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      width = Math.max(1, canvas.clientWidth);
      height = Math.max(1, canvas.clientHeight);
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      const count = window.innerWidth < 760 ? 82 : 150;
      particles = Array.from({ length: count }, (_, index) => ({
        x: Math.random() * width,
        y: Math.random() * height,
        r: 0.7 + Math.random() * 2.2,
        a: 0.18 + Math.random() * 0.6,
        s: 0.2 + Math.random() * 0.9,
        hue: index % 5,
      }));
    };

    const draw = (time) => {
      context.clearRect(0, 0, width, height);
      const driftX = (pointerX - 0.5) * 28;
      const driftY = (pointerY - 0.5) * 20;
      const colors = ['255,255,255', '210,210,210', '180,180,180', '255,255,255', '132,132,132'];

      particles.forEach((p, index) => {
        const wave = Math.sin(time * 0.00035 * p.s + index) * 18;
        const x = (p.x + driftX * p.s + wave + width) % width;
        const y = (p.y + driftY * p.s + Math.cos(time * 0.00028 * p.s + index) * 12 + height) % height;
        context.beginPath();
        context.fillStyle = 'rgba(' + colors[p.hue] + ',' + p.a + ')';
        context.arc(x, y, p.r, 0, Math.PI * 2);
        context.fill();
      });

      const gradient = context.createRadialGradient(width * 0.66, height * 0.24, 20, width * 0.66, height * 0.24, Math.max(width, height) * 0.58);
      gradient.addColorStop(0, 'rgba(255, 255, 255, 0.16)');
      gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
      context.fillStyle = gradient;
      context.fillRect(0, 0, width, height);

      animationFrame = window.requestAnimationFrame(draw);
    };

    canvas.addEventListener('pointermove', (event) => {
      const rect = canvas.getBoundingClientRect();
      pointerX = (event.clientX - rect.left) / rect.width;
      pointerY = (event.clientY - rect.top) / rect.height;
    }, { passive: true });

    window.addEventListener('resize', resize, { passive: true });
    resize();
    animationFrame = window.requestAnimationFrame(draw);
    document.addEventListener('shopify:section:unload', () => window.cancelAnimationFrame(animationFrame), { once: true });
  };

  const normalizeLabels = () => {
    const replacements = new Map([
      ['Disponibilidade', 'Availability'],
      ['Preço', 'Price'],
      ['Ordenar por', 'Sort by'],
      ['Ordenar', 'Sort'],
      ['Classificar', 'Sort'],
    ]);

    document.querySelectorAll('body *').forEach((element) => {
      element.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        const text = node.nodeValue || '';
        const trimmed = text.trim();
        const replacement = replacements.get(trimmed);
        if (replacement) node.nodeValue = text.replace(trimmed, replacement);
      });
    });
  };

  const init = () => {
    reveal();
    parallax();
    canvasHero();
    normalizeLabels();
    window.setTimeout(normalizeLabels, 600);
    window.setTimeout(normalizeLabels, 1800);

    let normalizeQueued = false;
    const scheduleNormalize = () => {
      if (normalizeQueued) return;
      normalizeQueued = true;
      window.requestAnimationFrame(() => {
        normalizeLabels();
        normalizeQueued = false;
      });
    };
    document.addEventListener('shopify:section:load', scheduleNormalize);
    if ('MutationObserver' in window) {
      new MutationObserver(scheduleNormalize).observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
